export default {
    en: {
        FLAG_TEXT_FLAG: 'Text flag',
        FLAGS_ADD_FLAG: 'Add a Flag',
        FLAG_MULTIPLE_CHOICE_FLAG: 'Multiple choice flags',
        FLAGS_ADD_CHOICE: 'Add a Choice',
        FLAG_PROMPT_FLAG: 'Prompt flag',
        FLAGS_ADD_PROMPT: 'Add AI Evaluation Criteria',
        FLAGS_PROMPT_VALUE: 'AI Evaluation Criteria',
        FLAGS_PROMPT_FLAG_GROUP_LABEL: 'prompt flag',
        FLAGS_PROMPT_NOT_AUTHORIZED: 'You do not have permission to modify prompt flags.',
        FLAGS_PROMPT_TEST_NOT_AUTHORIZED: 'You do not have permission to test prompt flags.',
        FLAGS_TYPE: 'Type',
        FLAGS_VALUE: 'Flag',
        FLAGS_MAX_CHOICES_TOOLTIP: 'Max number of choices ({count}) reached.',
        FLAGS_MIN_CHOICES_ERROR: 'Error: At least {count} choices are required',
        FLAGS_CHOICE_REQUIRED_ERROR: 'A correct choice is required.',
        DELETE_FLAG_WITH_VALUE_LABEL: 'Delete flag with value {text}.',
        DELETE_UNUSED_FLAG_WITH_TYPE: 'Delete unused flag of type {text}.',
        DELETE_UNUSED_MULTIPLE_CHOICE_FLAG: 'Delete unused multiple choice option.',
        FLAGS_FLAG_DELETED_ANNOUNCEMENT: 'deleted {label}',
        FLAGS_FLAG_GROUP_LABEL: 'flag {position} of {count}',
        FLAGS_CHOICE_GROUP_LABEL: 'choice option {position} of {count}'
    }
};